// @flow

import * as React from 'react';
import Group from 'sail/Group';
import {useSidebar} from 'docs/data';
import {CountrySelector} from './CountrySelector';
import {LocaleSelector} from './LocaleSelector';

type SidebarFooterProps = {|
  showLabels?: boolean,
|};

export const SidebarFooter = ({showLabels = true}: SidebarFooterProps) => {
  const {open} = useSidebar();
  const fullWidth = showLabels && open;
  return (
    <Group
      spacing={8}
      padding={{horizontal: 20, vertical: 12}}
      divider={fullWidth ? {color: 'light', width: 1, side: 'top'} : {}}
    >
      <CountrySelector showLabel={fullWidth} />
      <LocaleSelector showLabel={fullWidth} />
    </Group>
  );
};
